export default __webpack_public_path__ + "static/media/integrated_shipping.00a6f80d.png";